import { PropsWithChildren } from 'react';

import { DataGridBody, DataGridCell, DataGridRow } from '@twilio-paste/core/data-grid';

interface DataGridEmptyStateProps {
  colSpan: number;
}

export const DataGridEmptyState = ({
  children,
  colSpan,
}: PropsWithChildren<DataGridEmptyStateProps>) => (
  <DataGridBody>
    <DataGridRow>
      <DataGridCell colSpan={colSpan} textAlign="center">
        {children}
      </DataGridCell>
    </DataGridRow>
  </DataGridBody>
);
